// @ts-strict-ignore
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromContacts from '../reducers/contact.reducer';
import { selectRouteParams } from './router.selectors';
import { sortByPropertyWithOrder } from '@fc-shared/utils/sort-by-property';
import { Contact } from 'src/app/crm/models/contact.model';
import { SortBy } from '@fc-shared/ui/sort-by/sort-by';
import * as fromContact from '@fc-store/reducers/contact.reducer';

export const getContactState =
  createFeatureSelector<fromContact.State>('contact');
export const selectEntities = createSelector(
  getContactState,
  fromContacts.selectEntities,
);

export const getContactById = (id: string) => {
  return createSelector(selectEntities, (entities) => {
    return entities[id];
  });
};

export const getContactLoading = createSelector(
  getContactState,
  fromContacts.getContactLoading,
);

export const getContactSearch = createSelector(
  getContactState,
  fromContacts.getContactSearch,
);

export const getContactSortBy = createSelector(
  getContactState,
  fromContacts.getContactSortBy,
);

export const getContactSortList = createSelector(
  getContactState,
  fromContacts.getContactSortByList,
);

export const getContactList = createSelector(
  getContactState,
  fromContacts.selectAll,
);

export const getFilteredContactList = createSelector(
  getContactList,
  getContactSearch,
  getContactSortBy,
  (contacts: Contact[], search: string, sortBy: SortBy) => {
    contacts = contacts.filter((contact) => {
      return (
        contact.firstName.toLowerCase().includes(search.toLowerCase()) ||
        contact.lastName.toLowerCase().includes(search.toLowerCase())
      );
    });
    contacts = sortByPropertyWithOrder<Contact>(
      contacts,
      sortBy.value,
      sortBy.order,
    );
    return contacts;
  },
);

export const getSelectedContact = createSelector(
  getContactState,
  fromContacts.getSelectedContact,
);

export const getContactError = createSelector(
  getContactState,
  fromContacts.getContactError,
);

export const getActiveContact = createSelector(
  selectEntities,
  selectRouteParams,
  (entities, params) => entities[params.id],
);
